import { IRAAutoMaxSubmissionState } from '.';
import { IRAAutoMaxSubmissionActionTypes as act } from './actionTypes';
import {
  createApiPostActionCreator,
  createApiPutActionCreator,
} from 'src/redux/utils/createApiPostActionCreator';
import { snakeCase, toUpper } from 'lodash';
import { analyticsDataLayer } from '../../../utils/analytics-helper';

export const defaultState: IRAAutoMaxSubmissionState = {
  // Window API Fetch
  isLoading: false,
  loading: false,
  validationFailed: false,
  isLoaded: false,
  hasFailed: false,
  error: null,
  contributions: [],
};

export default function iraAutoMaxSubmission(
  state: IRAAutoMaxSubmissionState = defaultState,
  { payload, type }
): IRAAutoMaxSubmissionState {
  switch (type) {
    case act.IRA_AUTO_MAX_SUBMISSION_PENDING:
      return {
        ...state,
        isLoaded: false,
        isLoading: true,
      };
    case act.IRA_AUTO_MAX_SUBMISSION_FULFILLED:
      const { body } = payload;
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        ...body,
      };

    case act.IRA_AUTO_MAX_SUBMISSION_REJECTED:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        hasFailed: true,
        error: payload,
      };

    default:
      return state;
  }
}

export function submitIRAAutoMax(payload) {
  analyticsDataLayer({
    accountTypes: toUpper(
      snakeCase(
        payload.autoMaxContributionSchedule.contributions[0].agreementKey
          .productType
      )
    ),
    amount: payload.autoMaxContributionSchedule.maxContributionLimit,
    quantity: payload.autoMaxContributionOptions.agreementKeys.length,
  });
  return createApiPostActionCreator(
    act.IRA_AUTO_MAX_SUBMISSION,
    'iraAutoMaxSubmit',
    payload
  );
}

export function editIRAAutoMax(payload) {
  return createApiPutActionCreator(
    act.IRA_AUTO_MAX_SUBMISSION,
    'iraAutoMaxSubmit',
    payload
  );
}
